import { usuarioSchema } from '../../services/validators';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { useMemo } from 'react';

export default function Usuarios() {
    const keyField = 'codigo_usuario';

    const usuariosEndpoints = useMemo(() => ({
        listar: ENDPOINTS.usuarios.listar,
        crear: ENDPOINTS.usuarios.crear,
        actualizar: ENDPOINTS.usuarios.actualizar,
        borrar: ENDPOINTS.usuarios.borrar
    }), []);

    const baseColumns = [
        { label: 'No', key: 'index', align: 'center', render: (_, i) => i + 1 },
        { label: 'Documento', key: 'documento_identificacion', width: '20%' },
        { label: 'Nombre', key: 'nombre', width: '20%' },
        { label: 'Apellido', key: 'apellidos', width: '20%' },
        { label: 'Celular', key: 'celular', width: '20%' },
        { label: 'Email', key: 'correo_electronico', width: '30%' }
    ];

    // Para la tabla (sin contraseña)
    const columnsTable = baseColumns;

    // Para crear usuario (con contraseña y confirmación)
    const columnsCrear = [
        ...baseColumns,
        { label: 'Contraseña', key: 'contrasena', width: '200px', type: 'password' },
        { label: 'Confirmar Contraseña', key: 'contrasena_confirmation', width: '200px', type: 'password' }
    ];

    // Para editar usuario (con contraseña pero sin confirmación)
    const columnsEditar = [
        ...baseColumns,
        { label: 'Contraseña', key: 'contrasena', width: '200px', type: 'password' }
    ];

    const initForm = () => {
        const obj = {};
        columnsCrear.forEach(col => {
            if (col.key !== 'index') obj[col.key] = '';
        });
        return obj;
    };

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(usuariosEndpoints, { keyField, initForm, columns: columnsCrear, schema: usuarioSchema });
    // console.log('data:', formData);
    const getModalColumns = (action) => {
        switch (action) {
            case 'crear':
                return columnsCrear;
            case 'editar':
                return columnsEditar;
            case 'consultar':
                return columnsTable;
            default:
                return columnsTable;
        }
    };

    if (loading) return <Loading mensaje="Cargando Usuarios..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Usuarios"
                data={data}
                columns={columnsTable}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Usuario"
                columns={getModalColumns(actionType)}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
